var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneAudience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 164,
    viewBox: "0 0 299 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3310_35016)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3310_35016",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 299,
    height: 164
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.79 0H0.0830078V163.612H298.79V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3310_35016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6588 54.678C51.3206 49.266 48.4779 44.7855 45.1391 39.3735C44.6264 38.5421 43.4007 37.0023 42.5103 37.812C41.8762 38.389 42.2949 41.0768 45.1983 45.0458C42.3606 40.7429 40.9888 38.8761 38.1512 34.5731C37.7922 34.0292 37.326 33.4251 36.7571 33.4879C36.1746 33.5518 35.8348 34.3426 35.9132 35.0327C35.9921 35.7227 36.3647 36.3219 36.7242 36.8859C38.7888 40.1204 38.6735 40.5377 40.738 43.7723C38.137 39.518 38.0202 38.9156 34.9798 35.083C34.4762 34.4481 33.7541 33.7602 33.1059 34.1093C31.6709 35.1577 33.6707 37.8981 35.1856 40.0642C36.0533 41.3052 36.8926 42.4754 39.035 45.3403C36.7976 42.5723 36.0148 41.3134 33.7718 38.5519C33.3506 38.0334 32.8935 37.4899 32.3085 37.3227C31.7235 37.1555 31.0004 37.5663 30.9923 38.2704C30.9872 38.7186 31.2573 39.1099 31.5116 39.4542C33.8699 42.6481 34.4817 44.0218 36.84 47.2152C35.0976 44.9246 34.9105 44.6545 32.8268 42.8072C32.2079 42.2589 31.2441 41.768 30.7905 42.4679C30.3719 43.1147 30.8856 44.0445 31.3735 44.6626C36.1761 50.7474 40.0736 54.8545 44.8762 60.9392",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6588 54.678C51.3206 49.266 48.4779 44.7855 45.1391 39.3735C44.6264 38.5421 43.4007 37.0023 42.5103 37.812C41.8762 38.389 42.2949 41.0768 45.1983 45.0458C42.3606 40.7429 40.9888 38.8761 38.1512 34.5731C37.7922 34.0292 37.326 33.4251 36.7571 33.4879C36.1746 33.5518 35.8348 34.3426 35.9132 35.0327C35.9921 35.7227 36.3647 36.3219 36.7242 36.8859C38.7888 40.1204 38.6735 40.5377 40.738 43.7723C38.137 39.518 38.0202 38.9156 34.9798 35.083C34.4762 34.4481 33.7541 33.7602 33.1059 34.1093C31.6709 35.1577 33.6707 37.8981 35.1856 40.0642C36.0533 41.3052 36.8926 42.4754 39.035 45.3403C36.7976 42.5723 36.0148 41.3134 33.7718 38.5519C33.3506 38.0334 32.8935 37.4899 32.3085 37.3227C31.7235 37.1555 31.0004 37.5663 30.9923 38.2704C30.9872 38.7186 31.2573 39.1099 31.5116 39.4542C33.8699 42.6481 34.4817 44.0218 36.84 47.2152C35.0976 44.9246 34.9105 44.6545 32.8268 42.8072C32.2079 42.2589 31.2441 41.768 30.7905 42.4679C30.3719 43.1147 30.8856 44.0445 31.3735 44.6626C36.1761 50.7474 40.0736 54.8545 44.8762 60.9392",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1985 45.0464C44.4425 46.0412 43.7624 47.1232 43.365 48.3323C42.9671 49.542 42.869 50.8952 43.2679 52.1043",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1734 162.934C48.056 153.178 41.7314 144.501 38.6708 134.309C37.9108 131.778 37.3566 129.107 37.6782 126.47C38.5833 119.05 52.8656 111.55 66.8648 132.297C74.5531 143.692 79.0315 150.622 84.4697 162.651C71.2851 163.096 60.8659 162.933 52.1729 162.933L52.1734 162.934Z",
    fill: "#7DC97F",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6465 162.934C52.3292 158.876 49.4597 154.273 47.1423 150.216C45.1056 146.65 43.0229 143.025 40.081 140.278C37.1761 137.565 33.4925 135.821 29.6628 135.345C26.6907 134.976 23.3054 135.555 21.4765 138.09C19.8473 140.349 19.908 143.498 20.3302 146.316C21.2828 152.678 23.7114 158.781 27.4936 163.06C34.9508 163.005 42.9607 163.495 54.6465 162.934Z",
    fill: "#7DC97F",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7134 119.823C45.8573 122.776 60.8612 149.195 68.6298 162.951",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7944 136.023C30.5916 144.9 35.2147 153.652 40.3839 162.963",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3061 129.739L59.4336 146.424",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9619 135.244L53.9987 137.226",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.16 147.49L36.9028 156.656",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8832 85.6815C61.4365 85.7892 59.7978 86.0052 58.9452 87.2614C58.43 88.0208 58.3243 89.014 58.4715 89.8372C64.032 111.252 67.4931 132.124 74.7855 152.547C76.04 157.378 78.0074 156.773 79.6214 156.863C83.5214 157.082 136.407 156.627 169.527 156.634C170.804 156.634 172.054 155.535 172.186 154.176C172.323 152.756 171.033 148.653 169.504 143.988C165.935 130.657 157.374 101.042 153.946 88.2341C153.44 86.3467 151.583 84.9817 149.75 85.0347C135.038 85.4607 64.4208 85.5673 62.8832 85.6815Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.741 4.6109C173.237 2.18392 176.545 4.83985 178.367 7.63271C179.679 9.64455 180.699 11.9768 180.719 14.4303C180.74 16.9948 179.672 19.5414 180.117 22.062C180.469 24.0581 181.746 25.8248 181.793 27.8556C181.848 30.2468 180.173 32.5131 180.641 34.8518C180.882 36.0561 181.661 37.0493 182.098 38.1887C182.775 39.9515 182.566 42.0732 181.558 43.6451C170.483 43.3571 159.407 43.0697 148.242 42.8586C143.851 42.0386 140.683 41.8145 135.148 40.7807C134.284 40.6194 133.371 40.2904 132.855 39.5315C132.188 38.5502 132.484 37.1413 133.088 36.1135C133.691 35.0857 134.56 34.2516 135.106 33.188C136.63 30.2225 135.317 25.4459 136.891 22.5107C137.804 20.8085 139.55 19.7508 140.42 18.0232C141.556 15.7661 140.958 12.8699 142.032 10.5782C143.278 7.91795 146.674 7.75178 149.099 6.29689C151.955 4.58384 154.343 1.90842 157.472 0.878415C159.814 0.107126 162.367 0.349608 164.714 1.10466C167.061 1.85971 169.544 3.00392 170.741 4.6109Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8833 90.0273C67.4497 109.839 73.0234 132.452 78.8464 151.806C113.131 151.806 133.98 151.896 167.347 151.896C161.936 133.912 149.796 89.7307 149.796 89.7307C149.796 89.7307 66.444 89.9662 62.8833 90.0273Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.337 9.9683C170.166 11.5894 171.87 12.5961 172.83 13.8626C173.859 15.2195 174.068 17.0793 174.078 18.8265C174.105 23.3254 172.895 31.6553 171.452 34.6403C169.867 37.9187 167.571 39.1603 164.04 39.1603C163.62 42.4203 162.948 46.0862 162.331 49.3094C166.283 49.3711 170.232 49.7137 174.143 50.3334C173.525 53.8624 172.799 57.4075 171.368 60.6551C169.966 63.8376 167.922 66.6484 165.724 69.2643C163.917 71.4141 161.972 73.4714 159.67 74.9848C156.449 77.1022 152.58 78.0688 148.817 77.6965C147.4 77.5563 145.978 77.2229 144.734 76.4819C143.544 75.7723 142.564 74.7185 141.686 73.6029C137.322 68.0573 135.186 60.1062 137.601 53.3314C138.184 51.6974 139.025 49.9497 138.523 48.2144C139.381 47.501 139.596 47.0729 140.683 47.0729C142.385 47.0729 145.594 47.6856 147.017 47.37C147.524 45.9536 148.02 44.1398 148.314 42.4349C150.934 43.1856 151.822 43.2354 153.011 43.0822C155.597 42.7494 154.804 38.31 154.772 37.2978C154.674 34.1873 156.463 34.1748 155.478 28.3693C152.56 30.4315 150.29 26.0062 151.999 23.0174C152.615 21.9403 153.651 21.1382 154.808 20.8919C155.383 20.7696 155.995 20.7842 156.533 21.0299C157.072 21.2756 157.526 21.7725 157.824 22.4312C159.112 22.2423 159.591 20.5146 160.614 19.6567C161.275 19.103 162.166 18.9233 162.796 18.3291C163.745 17.4317 163.923 15.757 165.032 15.0999C165.392 14.8861 165.808 14.8125 166.2 14.6772C168.18 13.9947 169.386 11.8004 170.337 9.96667L170.337 9.9683Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.669 81.8597C110.736 94.6225 106.102 108.891 101.799 122.381C121.817 126.68 141.741 129.916 161.761 132.18C165.966 113.894 171.436 95.3126 175.469 77.776C179.799 84.4291 184.529 92.5316 189.635 98.8042C199.636 111.091 208.183 112.483 215.309 110.088C222.21 107.769 235.607 99.116 242.237 40.4922C234.395 39.2094 229.645 39.2452 222.374 38.056C217.815 56.5778 214.608 68.8875 209.555 89.4189C206.831 85.9787 203.615 74.9901 194.026 61.7462C190.991 57.5547 187.307 53.7519 182.783 51.5901C179.217 49.8851 175.203 49.267 171.332 49.8251C164.917 56.66 157.324 62.6788 151.174 69.4315C147.854 61.8658 144.086 55.1954 141.165 47.121C127.645 45.7094 119.096 51.077 110.442 58.0299C101.789 64.9829 94.4151 73.6153 85.8308 80.6663C74.1394 69.7308 63.8126 58.7206 54.4012 46.8769C50.3889 52.3608 44.5861 57.3615 40.1284 63.5859C44.8248 68.7614 58.4569 85.5121 68.7158 94.6534C73.5943 99.0002 79.5487 103.271 85.8404 102.375C88.6538 101.975 91.4889 101.224 93.9711 99.7504C99.5564 96.4341 109.118 88.6801 116.668 81.8597H116.669Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.437 37.5311C160.284 39.0088 162.794 39.215 164.714 39.1446",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.08 21.649C170.623 23.3908 171.257 25.1001 171.978 26.7661C171.276 27.4286 170.417 27.8989 169.504 28.1208",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.973 122.462C99.2869 131.889 96.1772 141.626 92.9082 151.422C102.649 151.402 109.801 151.45 121.5 151.45C123.353 148.945 126.809 144.948 126.809 144.948C126.809 144.948 128.037 149.427 128.988 151.46C138.774 151.431 148.307 150.996 157.516 151.023C158.332 149.019 160.764 136.688 161.761 132.179C156.78 130.068 120.718 120.38 101.973 122.462Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.315 69.1874C144.905 90.765 140.311 107.58 134.12 128.42",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8274 1.67297C69.8274 1.67297 48.4367 1.69841 46.895 1.69192C46.936 9.37067 46.9764 15.9669 47.0174 23.6462C51.6526 23.4676 69.8279 23.7599 69.8279 23.7599L69.8274 1.67297Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.860847 1.69189L0.462402 23.7594C0.462402 23.7594 34.5239 24.1269 47.0173 23.6457C46.9763 15.9669 46.9359 9.37067 46.8949 1.69135C36.7649 1.64914 0.860847 1.69189 0.860847 1.69189Z",
    fill: "#D4CCF3",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5642 7.33615C52.5095 8.01542 51.7646 9.22079 51.5932 10.5263C51.4491 11.6261 51.6974 12.7546 52.1439 13.757C52.518 14.5965 53.0606 15.3922 53.8363 15.8106C54.5411 16.1905 55.3633 16.2208 56.1521 16.1829C57.1462 16.1353 58.1529 15.9865 59.059 15.5448C59.9651 15.1031 60.7666 14.3394 61.1155 13.3419C61.5089 12.2166 61.2024 10.9696 60.7651 9.86326C59.2658 6.07448 55.3527 6.1849 53.5647 7.33669L53.5642 7.33615Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0874 15.4397L63.7983 19.2279",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50586 17.7244C8.49489 15.8971 9.08194 13.809 10.3218 12.1663C11.5616 10.5235 13.8178 9.43508 15.5228 10.4976C16.6559 11.2039 17.2121 12.6334 18.2143 13.5378C19.4183 14.6241 21.1405 14.8254 22.6923 14.5397C24.2441 14.2539 25.6943 13.5437 27.1778 12.9787C27.7709 12.753 28.4273 12.55 29.0184 12.7822C29.6944 13.048 30.0954 13.81 30.7345 14.1651C31.362 14.5142 32.1149 14.4211 32.8157 14.3199C34.6906 14.0482 36.565 13.7759 38.44 13.5042",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.029 29.2725C208.558 30.4297 228.133 30.6836 247.683 30.033C246.28 29.6806 245.467 28.3605 245.021 27.1227C243.685 23.4086 245.507 18.0832 247.914 15.0505C228.21 16.6153 208.287 19.3519 189.117 22.0262C186.7 22.6227 186.612 26.0034 187.21 27.8983C187.431 28.5976 187.879 29.2054 189.03 29.2736L189.029 29.2725Z",
    fill: "#1E96BE",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.605 17.2898C245.865 14.9099 247.945 14.747 249.215 15.1415C252.722 16.23 252.426 23.8741 251.2 27.3825C250.747 28.6778 249.898 30.0368 248.612 30.1705C247.435 30.2934 245.647 29.8664 244.957 28.838C242.793 25.6121 242.333 21.5776 244.604 17.2898H244.605Z",
    fill: "#1E96BE",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.227 18.9011C246.943 17.2454 248.125 17.1323 248.848 17.4067C250.843 18.1639 250.674 23.4812 249.977 25.9222C249.72 26.8234 249.237 27.7685 248.506 27.8621C247.837 27.9476 246.82 27.6505 246.427 26.9349C245.197 24.6909 244.936 21.8845 246.227 18.9016L246.227 18.9011Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.519 39.8178C238.263 38.0777 238.917 34.1904 238.319 30.3838C238.269 30.282 230.786 30.3091 227.346 30.1916C226.914 29.4555 226.463 27.4204 226.084 26.7655C225.938 26.5133 225.777 26.2578 225.538 26.1062C225.118 25.8394 224.547 25.979 224.186 26.3314C223.825 26.6837 223.644 27.2039 223.562 27.7192C223.391 28.8028 223.984 31.8029 224.197 32.8784C224.575 34.7885 224.967 36.9838 225.969 38.5778C228.499 38.7607 237.518 39.8173 237.518 39.8173L237.519 39.8178Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.875 90.0046C252.562 90.777 243.726 97.2222 240.097 106.435C236.467 115.649 238.489 127.224 245.315 134.05C248.145 136.879 251.64 138.862 255.276 140.289C259.565 141.971 264.152 142.922 268.709 142.589C273.267 142.256 277.797 140.585 281.316 137.466C287.382 132.087 289.694 122.923 288.671 114.561C287.304 103.386 277.312 88.5216 261.875 90.0046Z",
    fill: "#1E96BE",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.322 96.7594C255.404 97.3331 248.839 102.122 246.143 108.966C243.446 115.81 244.948 124.41 250.02 129.48C252.122 131.583 254.718 133.055 257.42 134.115C260.606 135.365 264.014 136.072 267.4 135.824C270.786 135.576 274.151 134.335 276.765 132.018C281.272 128.022 282.989 121.213 282.229 115.002C281.214 106.699 273.791 95.6568 262.322 96.7588L262.322 96.7594Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.935 106.327C259.518 106.61 256.276 108.975 254.944 112.356C253.612 115.736 254.354 119.984 256.859 122.488C257.897 123.526 259.179 124.253 260.513 124.777C262.087 125.395 263.77 125.744 265.443 125.621C267.115 125.499 268.778 124.886 270.068 123.741C272.294 121.767 273.143 118.405 272.768 115.337C272.266 111.236 268.6 105.782 262.935 106.327H262.935Z",
    fill: "#1E96BE",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.356 112.687C262.193 112.784 261.09 113.589 260.637 114.739C260.184 115.889 260.436 117.334 261.288 118.186C261.642 118.539 262.078 118.787 262.532 118.965C263.067 119.175 263.639 119.293 264.209 119.252C264.778 119.211 265.343 119.002 265.782 118.612C266.54 117.941 266.828 116.797 266.701 115.753C266.53 114.358 265.283 112.502 263.355 112.687H263.356Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.085 115.306C273.437 108.449 282.908 101.776 292.49 95.2931",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.569 99.1772C287.175 97.3927 287.727 95.5871 288.224 93.7647C288.47 93.8567 291.52 91.4503 295.87 89.1694C295.671 90.2368 295.472 92.6573 295.272 93.7252C296.333 94.0624 297.381 94.4488 298.411 94.8818C296.945 96.9786 291.19 100.063 291.19 100.063C291.19 100.063 288.389 99.4219 286.568 99.1778L286.569 99.1772Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.814 156.887H81.6206C80.0886 156.887 78.8462 158.217 78.8462 159.857C78.8462 161.497 80.0886 162.828 81.6206 162.828H209.814C211.346 162.828 212.588 161.498 212.588 159.858C212.588 158.218 211.346 156.887 209.814 156.887Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.311 156.635C134.456 157.033 133.657 157.62 133.126 158.441C132.596 159.262 132.365 160.337 132.654 161.286C132.943 162.234 133.807 162.992 134.738 162.963",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.456 156.829C168.65 157.854 168.928 159.007 169.787 159.505C170.279 159.791 170.867 159.795 171.427 159.792C174.748 159.775 178.069 159.759 181.389 159.741C181.623 159.74 181.863 159.738 182.08 159.647C182.94 159.289 182.888 157.952 183.44 157.162",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5757 105.761C23.5364 107.589 23.8469 106.714 21.8076 108.542",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.317 125.33C187.778 126.944 188.238 128.558 188.699 130.172",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.347 30.1917C227.514 30.8969 227.775 31.4555 227.914 32.1569C229.106 31.7299 230.463 31.8647 231.561 32.5201C232.658 33.175 233.479 34.3404 233.766 35.6502",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.251 62.0228C257.97 62.1175 257.83 62.5159 257.966 62.7952C258.103 63.0745 258.465 63.186 258.729 63.0453C258.991 62.9056 259.127 62.5327 259.002 62.2496C258.878 61.9665 258.533 61.9276 258.251 62.0228Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1904 39.2208C76.8668 39.3296 76.7055 39.7886 76.8623 40.1106C77.019 40.4327 77.4372 40.5604 77.7411 40.3986C78.0424 40.2378 78.1992 39.8081 78.0556 39.4822C77.912 39.1564 77.5156 39.1115 77.1904 39.2208Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.062 77.1784C152.738 77.2872 152.577 77.7462 152.733 78.0683C152.89 78.3903 153.308 78.5181 153.612 78.3562C153.914 78.1955 154.07 77.7657 153.927 77.4399C153.783 77.114 153.387 77.0691 153.062 77.1784Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.143 91.5168C148.819 91.6256 148.658 92.0846 148.815 92.4067C148.972 92.7287 149.39 92.8564 149.694 92.6946C149.995 92.5338 150.152 92.1041 150.008 91.7783C149.865 91.4524 149.468 91.4075 149.143 91.5168Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.452 104.702C145.129 104.811 144.967 105.27 145.124 105.592C145.281 105.914 145.699 106.042 146.003 105.88C146.304 105.719 146.461 105.29 146.317 104.964C146.174 104.638 145.777 104.593 145.452 104.702Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.947 117.836C141.623 117.945 141.462 118.404 141.619 118.726C141.775 119.048 142.194 119.176 142.497 119.014C142.799 118.853 142.956 118.424 142.812 118.098C142.668 117.772 142.272 117.727 141.947 117.836Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3310_35016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298.834,
    height: 164,
    fill: "white",
    transform: "translate(0.0830078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneAudience);
export default __webpack_public_path__ + "static/media/ONEAudience.4e56ab2eadcf5232bd9ec911e244f6a9.svg";
export { ForwardRef as ReactComponent };